import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';

const ModalCrearRendicionFondos = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        encabezadoData: {
            CLAEMP: '',
            TIPFOL: '',
            NUMFOL: '',
            CENRES: '',
            FECMOV: '',
            CLIPRO: '',
            VALENT: '',
            VALREN: '',
            TIPCOM: '',
            NUMCOM: '',
            TIPREN: '',
            DESCRI: '',
            TIPEGR: '',
            EGRESO: '',
            TIPING: '',
            ORIGEN: '',
            USUCRE: ''
        },
        detallesData: []
    });

    const handleInputChange = (e, section) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [name]: value
            }
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    const resetForm = () => {
        setFormData({
            encabezadoData: {
                CLAEMP: '',
                TIPFOL: '',
                NUMFOL: '',
                CENRES: '',
                FECMOV: '',
                CLIPRO: '',
                VALENT: '',
                VALREN: '',
                TIPCOM: '',
                NUMCOM: '',
                TIPREN: '',
                DESCRI: '',
                TIPEGR: '',
                EGRESO: '',
                TIPING: '',
                ORIGEN: '',
                USUCRE: ''
            },
            detallesData: []
        });
    };

    const handleToggle = () => {
        if (!isOpen) resetForm();
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleToggle} size="lg">
            <ModalHeader toggle={handleToggle}>Crear Rendición de Fondos</ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <h6>Encabezado</h6>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="CLAEMP">Empresa</Label>
                                <Input
                                    type="number"
                                    name="CLAEMP"
                                    id="CLAEMP"
                                    value={formData.encabezadoData.CLAEMP}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                    required
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="TIPFOL">Tipo Folio</Label>
                                <Input
                                    type="text"
                                    name="TIPFOL"
                                    id="TIPFOL"
                                    value={formData.encabezadoData.TIPFOL}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                    required
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="NUMFOL">N° Folio</Label>
                                <Input
                                    type="number"
                                    name="NUMFOL"
                                    id="NUMFOL"
                                    value={formData.encabezadoData.NUMFOL}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="FECMOV">Fecha Movimiento</Label>
                                <Input
                                    type="date"
                                    name="FECMOV"
                                    id="FECMOV"
                                    value={formData.encabezadoData.FECMOV}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="CLIPRO">Cliente Proveedor</Label>
                                <Input
                                    type="text"
                                    name="CLIPRO"
                                    id="CLIPRO"
                                    value={formData.encabezadoData.CLIPRO}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="VALENT">Valor Entregado</Label>
                                <Input
                                    type="number"
                                    name="VALENT"
                                    id="VALENT"
                                    value={formData.encabezadoData.VALENT}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="VALREN">Valor Rendición</Label>
                                <Input
                                    type="number"
                                    name="VALREN"
                                    id="VALREN"
                                    value={formData.encabezadoData.VALREN}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <FormGroup>
                                <Label for="DESCRI">Descripción</Label>
                                <Input
                                    type="textarea"
                                    name="DESCRI"
                                    id="DESCRI"
                                    value={formData.encabezadoData.DESCRI}
                                    onChange={(e) => handleInputChange(e, 'encabezadoData')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    {/* TODO: Add detalles section */}
                    <h6>Detalles (por implementar)</h6>
                    <p>La funcionalidad de detalles se implementará en una versión futura.</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" type="submit">Guardar</Button>
                    <Button color="secondary" onClick={handleToggle}>Cancelar</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalCrearRendicionFondos;